import { render } from "./DurationForm.vue?vue&type=template&id=333a8ec3"
import script from "./DurationForm.vue?vue&type=script&lang=js"
export * from "./DurationForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__